// ==============================|| LOADER ||============================== //
const Loader = () => <></>;

export default Loader;
